
<template>
  <vs-popup popup-class="w-11/12" :title='"قبض آزمایشی \""+shopName+"\""' :active.sync="popupActive">
    <form>
      <div class="vx-row">
        <div class="vx-col w-full">
          <vs-input
            label="شماره تلفن"
            v-validate="{required:true,regex: '^([+]98|0)?9[0-9]{9}$' }"
            name="mobile"
            v-model="mobile"
            class="w-full mt-4 ltr-input"
            placeholder="0912******"
          />
          <span class="text-danger text-sm" v-show="errors.has('mobile')">موبایل را درست وارد کنید</span>
        </div>
        <div class="vx-col w-full">
          <vs-input
            label="مبلغ"
            v-validate="'numeric|required|max:9'"
            name="amount"
            v-model="amount"
            class="w-full mt-4 ltr-input"
          />
          <span class="text-danger text-sm" v-show="errors.has('amount')">مبلغ را درست وارد کنید</span>
          <hr class="w-full" />
        </div>
        <div class="vx-col w-full">
          <vs-input label="عنوان" v-model="title" class="w-full mt-4" />
        </div>
        <div class="vx-col w-full">
          <vs-input label="توضیحات" v-model="description" class="w-full mt-4" />
        </div>
        <div class="vx-col w-full">
          <vs-input label="نام گیرنده" v-model="contactName" class="w-full mt-4" />
        </div>
        <div class="vx-col w-full">
          <vs-input label="توضیحات پذیرنده" v-model="merchantDescription" class="w-full mt-4" />
          <hr class="w-full" />
        </div>
        <div class="vx-col w-full">
          <vs-button @click.prevent="submitForm" color="primary" type="filled">ارسال</vs-button>
        </div>
      </div>
    </form>
  </vs-popup>
</template>
<style>
</style>
<script>
export default {
  name: "generate-test-bill",
  props: {},
  components: {},
  data() {
    return {
      popupActive: false,
      shopId: "",
      title: "قبض تستی",
      description: "توضیحات قبض تستی",
      mobile: "09169210690",
      contactName: "",
      amount: "1000",
      merchantDescription: "",
      shopName:'',
    };
  },
  methods: {
    show(shopId,shopName='') {
      this.popupActive = true;
      this.shopId = shopId;
      this.shopName=shopName;
    },
    submitForm() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.sendTestBill();
        } else {
          this.$vs.notify({
            time: 5000,
            color: "warning",
            title: "نقص اطلاعات!",
            text: "داده‌های خواسته شده را صحیح وارد کنید"
          });
        }
      });
    },
    sendTestBill() {
      let loading = this.$vs.loading();

      let payload = {
        ShopId: this.shopId,
        title: this.title,
        description: this.description,
        mobile: this.mobile,
        contactName: this.contactName,
        amount: this.amount,
        merchantDescription: this.merchantDescription
      };
      this.$http
        .post(`/api/services/app/Bills/CreateTestBill`, payload)
        .then(response => {
          console.log(response.data.result);
          if (response.data.result) {
            this.$vs.notify({
              time: 5000,
              color: "success",
              title: "موفق!",
              text: "قبض با موفقیت ارسال شد"
            });
            this.popupActive = false;
          }
          this.$vs.loading.close();
        }) //end success
        .catch(error => {
          console.log(error);
          this.$vs.loading.close();
        });
    }
  }
};
</script>